<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Supercard Type {{ (supercardType.name) ? (" - " + supercardType.name) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Supercard Type - {{supercardType.name}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Supercard Type - {{supercardType.name}}</h6>
        
        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory" :disabled="loading">
                <b><label>Created By: </label></b>
                {{ createdBy }} | {{ createdAt | dateFilter }}
                <br>
                <b><label>Updated By:</label></b>
                {{ updatedBy }} | {{ updatedAt | dateFilter }}
                <div class="card shadow">
                    <a-table :columns="supercardTypeUpdateHistoryColumns" :dataSource="supercardTypeUpdateHistoryData"
                        :loading="loading" :pagination="pagination" bordered>
                    </a-table>
                </div>
            </b-tab>
        </b-tabs>

        <form class="mb-5" id="form-proper">
          <div v-if="customFormMode == 1" v-show="showDetails">
            <base-input :readonly="isReadOnly" alternative="" label="Code" placeholder="" v-model="supercardType.code" input-classes="form-control" />

            <base-input :disabled="isReadOnly" alternative="" label="Name" placeholder="" v-model="supercardType.name" input-classes="form-control" required />

            <!-- Supercard Purchase Type -->
            <base-input alternative="" label="Supercard Purchase Type" required>
              <a-select
                  v-model="supercardType.supercard_purchase_type_id"
                  style="width: 100%;"
                  placeholder="Select Purchase Type"
                  :disabled="isReadOnly"
              >
                  <a-select-option
                      v-for="item in supercardPurchaseTypes"
                      :key="item.id"
                      :value="item.id"
                  >
                      {{ item.name }}
                  </a-select-option>
              </a-select>
            </base-input>
              
            <!-- Supercard Format -->
            <base-input alternative="" label="Supercard Format" required>
                <a-select
                    v-model="supercardType.supercard_format_id"
                    style="width: 100%;"
                    placeholder="Select Format"
                    :disabled="isReadOnly"
                >
                    <a-select-option
                        v-for="item in supercardFormats"
                        :key="item.id"
                        :value="item.id"
                    >
                        {{ item.name }}
                    </a-select-option>
                </a-select>
            </base-input>

            <base-input alternative="" label="Sites">
                <a-select mode="multiple" :value="supercardType.site_ids.active" @change="value => updateSiteIds(supercardType, value)" showSearch :autoClearSearchValue="false" placeholder="All Sites" optionFilterProp="children" style="width: 100%" :disabled="isReadOnly">
                    <a-select-option v-for="site in siteList" :key="site.id" :value="site.id">{{ site.name }}</a-select-option>
                </a-select>
            </base-input>

            <base-input alternative="" label="Remark">
                <textarea :disabled="isReadOnly" rows="4" class="form-control" v-model="supercardType.remark" />
            </base-input>

            <base-input alternative="">
              <label class="form-control-label">
                Disable New Supercard
              </label>

              <div class="mt-2">
                <a-switch
                  v-model="supercardType.disable_new_supercard"
                  :disabled="isReadOnly"
                />
              </div>
            </base-input>

            <!-- Maximum Backup Count -->
            <base-input
                v-if="enableReplenishment"
                :readonly="isReadOnly"
                alternative=""
                label="Maximum Backup Count"
                type="number"
                v-model="supercardType.settings.maximum_backup_count"
                input-classes="form-control"
                required
            />

            <!-- Replenishment Threshold -->
            <base-input
                v-if="enableReplenishment"
                :readonly="isReadOnly"
                alternative=""
                label="Replenishment Threshold"
                type="number"
                v-model="supercardType.settings.replenishment_threshold"
                input-classes="form-control"
                required
            />

            <!-- Welcome Discount Percentage -->
            <base-input
              v-if="enableWelcomeDiscount"
              label="Welcome Discount Percentage"
              required
            >
              <div>
                <!-- <a-input-number
                  v-model="welcomeDiscountUI"
                  :min="0"
                  :max="100"
                  :formatter="value => `${value}%`"
                  :parser="value => value.replace('%', '')"
                  :disabled="isReadOnly"
                  style="width: 100%;"
                /> -->
                <a-input
                  v-model="welcomeDiscountUI"
                  type="number"
                  suffix="%"
                  :min="0"
                  :max="100"
                  :disabled="isReadOnly"
                />
              </div>
            </base-input>

            <!-- Welcome Maximum Discount -->
            <base-input
                v-if="enableWelcomeDiscount"
                :readonly="isReadOnly"
                alternative=""
                label="Welcome Maximum Discount"
                type="number"
                v-model="supercardType.settings.welcome_maximum_discount"
                input-classes="form-control"
                required
            />
          </div>

          <div v-if="customFormMode == 2">
              <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="supercardType"  @valueUpdated="updateSettings" :key="dynamicFormKey"/>
          </div>

          <div v-if="customFormMode == 3">
            <a-tabs defaultActiveKey="1">
              <a-tab-pane tab="Basic" key="1">
                <base-input alternative="" label="Code" placeholder="" v-model="supercardType.code" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="supercardType.name" input-classes="form-control" required />
                <base-input alternative="" label="Sites">
                    <a-select mode="multiple" :value="supercardType.site_ids.active" @change="value => updateSiteIds(supercardType, value)" showSearch :autoClearSearchValue="false" placeholder="All Sites" optionFilterProp="children" style="width: 100%" :disabled="isReadOnly">
                        <a-select-option v-for="site in siteList" :key="site.id" :value="site.id">{{ site.name }}</a-select-option>
                    </a-select>
                </base-input>
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="supercardType.remark" />
                </base-input>
            </a-tab-pane>
            <a-tab-pane tab="Custom Fields" key="2" forceRender>
              <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="supercardType" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
            </a-tab-pane>
            </a-tabs>
          </div>

          <div v-if="this.$attrs.viewMode != true">
              <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                  <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                  <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
              </div>
              <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                  <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
              </div>
          </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    import DynamicForm from '../DynamicForm.vue'
    import moment from 'moment'

    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
            selectedFormat() {
              return this.supercardFormats.find(
                f => f.id === this.supercardType.supercard_format_id
              ) || {}
            },
            enableReplenishment() {
              return !!this.selectedFormat.enable_replenishment
            },
            enableWelcomeDiscount() {
              return !!this.selectedFormat.enable_welcome_discount
            },
            isReadOnly() {
              return this.serverType === 'branch' || this.$attrs.viewMode === true
            },
            welcomeDiscountUI: {
              get() {
                return (this.supercardType.settings.welcome_discount_percentage || 0) * 100
              },
              set(value) {
                const normalized = Math.min(100, Math.max(0, value || 0)) / 100
                this.supercardType.settings.welcome_discount_percentage = normalized
              }
            },
        },
        mounted: async function () {

            // Meta-data Call
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Supercard Types?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            // if(this.serverType == 'branch' || this.$attrs.viewMode == true){
            //     var form = document.getElementById("form-proper")
            //     var elements = form.elements;
            //     for (var i = 0, len = elements.length; i < len; ++i) {
            //         elements[i].readOnly = true;
            //     }
            // }

            // LOAD PURCHASE TYPES
            const supercardPurchaseTypesResponse = await HTTPRequest.getRequest(
                this.endPoint + 'supercard_purchase_types',
                null
            )

            if (supercardPurchaseTypesResponse && supercardPurchaseTypesResponse.data) {
                this.supercardPurchaseTypes = supercardPurchaseTypesResponse.data
            }

            // LOAD FORMATS
            const supercardFormatsResponse = await HTTPRequest.getRequest(
                this.endPoint + 'supercard_formats',
                null
            )

            if (supercardFormatsResponse && supercardFormatsResponse.data) {
                this.supercardFormats = supercardFormatsResponse.data
            }

            this.siteList = (await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites', null, null) || []).sort((a, b) => a.name.localeCompare(b.name))

            component_x = this
            if (component_x.profileId > 0) {
                var supercard_type_data = await HTTPRequest.getRequest(component_x.endPoint + 'supercard_types/' + component_x.profileId, null)
                if (supercard_type_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (supercard_type_data["error"] == undefined) {
                        component_x.supercardType = supercard_type_data
                        component_x.supercardType.site_ids = component_x.normalizeSiteIds(component_x.supercardType.site_ids)
                        component_x.originalActiveSiteIds = [...component_x.supercardType.site_ids.active]

                        if (!component_x.supercardType.settings) {
                            component_x.supercardType.settings = {
                                maximum_backup_count: '',
                                replenishment_threshold: '',
                                welcome_discount_percentage: '',
                                welcome_maximum_discount: ''
                            }
                        }
                        component_x.createdBy = supercard_type_data.created_by
                        component_x.updatedBy = supercard_type_data.updated_by
                        component_x.createdAt = supercard_type_data.created_at
                        component_x.updatedAt = supercard_type_data.updated_at
                    } else {
                        this.errors = supercard_type_data["error"].split(",")
                    }
                }
            }

            this.dynamicFormKey++;
            this.loading = false
        },
        data: function () {
            return {
                errors: [],
                // FOR META-DATA
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                supercardType: {
                    code: '',
                    name: '',
                    supercard_purchase_type_id: '',
                    supercard_format_id: '',
                    site_ids: { active: [], inactive: [] },
                    disable_new_supercard: true,

                    settings: {
                        maximum_backup_count: '',
                        replenishment_threshold: '',
                        welcome_discount_percentage: '',
                        welcome_maximum_discount: ''
                    }
                },
                supercardPurchaseTypes: [],
                supercardFormats: [],
                siteList: [],
                originalActiveSiteIds: [],

                formErrors: [],
                createdAt: '',
                updatedAt: '',
                createdBy: '',
                updatedBy: '',
                supercardTypeUpdateHistoryColumns: [
                    { title: "Action", dataIndex: "action", key: "action" },
                    { title: "Field Name", dataIndex: "field_name", key: "field_name" },
                    { title: "From", dataIndex: "old_value", key: "old_value" },
                    { title: "To", dataIndex: "new_value", key: "new_value" },
                    { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
                    // { title: "Updated At", dataIndex: "updated_at", key: "updated_at" },
                    { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
                ],
                supercardTypeUpdateHistoryData: null,
                loading: true,
                pagination: false,
                showDetails: true
            }
        },
        filters: {
            dateFilter: function (timestamp) {
                return moment(timestamp).format('L LTS')
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.supercardType
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors

                if(this.customFormMode == 3) {
                    this.errors = errors
                }

                this.supercardType = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            normalizeSiteIds(siteIds) {
                return {
                    active: (siteIds && siteIds.active) || [],
                    inactive: (siteIds && siteIds.inactive) || []
                }
            },
            updateSiteIds(record, active) {
                const siteIds = this.normalizeSiteIds(record.site_ids)
                const activeIds = active.map(id => id.toString())
                const originalActiveIds = this.originalActiveSiteIds.map(id => id.toString())
                const removed = siteIds.active.filter(id => !activeIds.includes(id.toString()) && originalActiveIds.includes(id.toString()))

                record.site_ids = {
                    active: active,
                    inactive: active.length ? [...new Set([...(siteIds.inactive || []), ...removed])].filter(id => !activeIds.includes(id.toString())) : []
                }
            },

            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.supercardType.code));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.supercardType.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.supercardType.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.supercardType.name));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.supercardType.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.supercardType.name, 0, 50));
                this.errors.push(ValidateField.required('Supercard Purchase Type',this.supercardType.supercard_purchase_type_id));
                this.errors.push( ValidateField.required('Supercard Format',this.supercardType.supercard_format_id));

                if (this.enableReplenishment) {
                  this.errors.push(
                    ValidateField.required(
                      'Maximum Backup Count',
                      this.supercardType.settings.maximum_backup_count
                    )
                  );

                  this.errors.push(
                    ValidateField.required(
                      'Replenishment Threshold',
                      this.supercardType.settings.replenishment_threshold
                    )
                  );
                }

                if (this.enableWelcomeDiscount) {
                  this.errors.push(
                    ValidateField.required(
                      'Welcome Discount Percentage',
                      this.supercardType.settings.welcome_discount_percentage
                    )
                  );

                  this.errors.push(
                    ValidateField.required(
                      'Welcome Maximum Discount',
                      this.supercardType.settings.welcome_maximum_discount
                    )
                  );
                }

                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    // var supercardTypePayload = {
                    //     supercard_type: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         operation_type: this.inputOperation
                    //     }
                    // }
                    this.supercardType.name = this.supercardType.name.trim()
                    this.supercardType.code = this.supercardType.code.trim()
                    this.supercardType.status = 'A'
                    var supercardTypePayload = { supercard_type: this.supercardType }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'supercard_types', null, supercardTypePayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    // var supercardTypePayload = {
                    //     supercard_type: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         operation_type: this.inputOperation
                    //     }
                    // }

                    this.supercardType.name = this.supercardType.name.trim()
                    this.supercardType.code = this.supercardType.code.trim()
                    let status = (this.supercardType.status == null) ?  "A" : this.supercardType.status
                    this.supercardType.status = status
                    // this.supercardType.status = 'A'
                    var supercardTypePayload = { supercard_type: this.supercardType }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'supercard_types/' + this.profileId, null, supercardTypePayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            },
            openDetails() {
                this.showDetails = true
            },
            async openHistory() {
                this.showDetails = false
                var supercardTypeUpdateHistoryData = await HTTPRequest.getRequest(
                    this.endPoint +
                    "supercard_type_update_histories?supercard_type_id=" +
                    this.supercardType.id,
                    null,
                    null
                );
                this.supercardTypeUpdateHistoryData = supercardTypeUpdateHistoryData;
            },
        }
    }
</script>

<style>
</style>
